require('./GlobalStockTable.scss');
const React = require('react');
const PropTypes = require('prop-types');
const ColorSwatch = require('components/charts/ColorSwatch/ColorSwatch');
const DataTable = require('components/charts/DataTable/DataTable');
const DataTableColumn = require('components/charts/DataTableColumn/DataTableColumn');
const rotateColor = require('utilities/rotateColor');
const stocksSectorHelper = require('utilities/stocksSectorHelper');
const { formatValue } = require('../utilities/valueFormater');
const { formatText } = require('core/i18n').i18n;

const GlobalStockTable = ({ colors, data, onMouseEnterRow }) => (
    <DataTable
        data={data}
        onMouseEnterRow={i => onMouseEnterRow && onMouseEnterRow(i)}
        returnIndex
    >
        <DataTableColumn
            format={(_, i) => <ColorSwatch color={rotateColor(colors, i)} />}
        />
        <DataTableColumn
            dataKey="type"
            format={v => stocksSectorHelper(v)}
            header={formatText('fundstable-sector')}
            className="header-align-left"
        />
        <DataTableColumn
            dataKey="value"
            format={v => `${formatValue(v)}%`}
            header={formatText('fundstable-fund')}
        />
        <DataTableColumn
            dataKey="benchmark"
            format={v => (v !== null ? `${formatValue(v)}%` : '')}
            header="BENCHMARK"
        />
    </DataTable>
);

GlobalStockTable.propTypes = {
    colors: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
    onMouseEnterRow: PropTypes.func,
};

module.exports = GlobalStockTable;
